module.exports = __webpack_public_path__ + "img/horizontal_6_6_pp1_8011.419f7a91.png";